module.exports = __webpack_public_path__ + "./docs/img/big-icon-error_class.d1c5dda9d54cdd8bfde903d6ef017546.svg";